import { NgModule, LOCALE_ID } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { registerLocaleData } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { DatePipe } from '@angular/common'

import localeEn from '@angular/common/locales/en';
import localeEnExtra from '@angular/common/locales/extra/en';

import { NgSelectModule } from '@ng-select/ng-select';
import { Angulartics2Module } from 'angulartics2';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { ToastrModule } from 'ngx-toastr';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { SharedModule } from './shared/shared.module';
import { NewJoineeApplicationComponent } from './components/new-joinee-application/new-joinee-application.component';
import { ViewApplicationComponent } from './components/view-application/view-application.component';
import { FileUploaderComponent } from './components/file-uploader/file-uploader.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { LoginComponent } from './components/login/login.component';
import { SelectedCandidateDetailFormComponent } from './components/selected-candidate-detail-form/selected-candidate-detail-form.component';
// import { NgxUiLoaderModule, NgxUiLoaderRouterModule } from  'ngx-ui-loader';


registerLocaleData(localeEn, 'en-IN', localeEnExtra);

@NgModule({
  declarations: [
    AppComponent,
    NewJoineeApplicationComponent,
    ViewApplicationComponent,
    FileUploaderComponent,
    LoginComponent,
    SelectedCandidateDetailFormComponent
  ],
  imports: [
    BrowserModule.withServerTransition({ appId: 'serverApp' }),
    BrowserAnimationsModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    BsDatepickerModule.forRoot(),
    AppRoutingModule,
    SharedModule,
    ToastrModule.forRoot({
      timeOut: 5000,
      positionClass: 'toast-top-center',
      preventDuplicates: true,
      progressBar: true,
      progressAnimation: 'decreasing',
      closeButton: true,
    }),
    Angulartics2Module.forRoot(),
    CarouselModule,
    NgSelectModule,
    NgxPaginationModule,
    // LoginComponent,
    // NgxUiLoaderRouterModule,
    // NgxUiLoaderModule
  ],
  providers: [{ provide: LOCALE_ID, useValue: 'en-IN' },
  DatePipe],
  bootstrap: [AppComponent]
})
export class AppModule { }
